/* línkè · 后视镜数据层（2026-08-14 铃点单）====================
   GET /api/recall/log（登录墙内）：回看最近每次「克克不用她喊、就悄悄
   记起的旧事」——她说的话 + 浮出的记忆 + 命中的关键词（含独特度，勾错
   一眼看得出）。只读，供她调准度用。
   ============================================================ */

export async function loadRecallLog() {
  const res = await fetch('/api/recall/log', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error('HTTP ' + res.status);
  return res.json();
}
